import React, { useRef, useEffect, useCallback, useState} from 'react';
import PanKnob from './PanKnob.js';
import ParameterKnob from 'components/knobs/ParameterKnob.js';
import TrackOutputType from "components/track/TrackOutputType.js";
import {connect} from 'react-redux';

const names = ['A', 'B', 'C', 'D', 'E'];

const TrackControls = ({track, isSelected}) => { 
    const scrollContainer = useRef(undefined);
    useEffect(() => {
        let elem = document.getElementById("mix-scroll");
        scrollContainer.current = elem;
    }, []);

    const onClickNext = useCallback(() => {
    }, []);

    const onClickPrevious = useCallback(() => {
    }, []);


    return (
        <div className="track-controls">
          {scrollContainer ? <PanKnob scrollContainer={scrollContainer} track={track}/> : ''}
          <div className="sends-label">
            Sends
          </div>
          <div className="send-knobs">
            {track.sendNodeVolumeParameters.map(
                (send, i) =>
                    <div style={{marginTop: i % 2 === 1 ? 10 : 0}} className="send-knob">
                {scrollContainer ?
                 <ParameterKnob
                   sequencerEngine={track.sequencerEngine}
                   scrollContainer={scrollContainer} min={-40} parameter={send}/>
                 : ''}
                      <div className="send-name">
                        {names[i]}
                      </div>
                    </div>)}
          </div>
          <TrackOutputType className="mix-output-type" track={track}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackControls);
